import { render, staticRenderFns } from "./MainHome.vue?vue&type=template&id=0f89661c&scoped=true&"
import script from "./MainHome.vue?vue&type=script&lang=js&"
export * from "./MainHome.vue?vue&type=script&lang=js&"
import style0 from "./MainHome.vue?vue&type=style&index=0&id=0f89661c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f89661c",
  null
  
)

export default component.exports